import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RoleKind } from '../models/brijjsports.enums';
import { BrijjSportsStateService } from '../state/brijjsports-state.service';

/**
 * Gates the role-prefixed routes. The user must be signed in via
 * `MockAuthService` (state.currentUserId set) AND their current role must
 * match the route's role. Anything else redirects to `/login`.
 */
export const roleGuard: (role: RoleKind) => CanActivateFn = role => () => {
  const state = inject(BrijjSportsStateService);
  const router = inject(Router);

  if (!state.currentUserId() || state.currentRole() !== role) {
    router.navigate(['/login']);
    return false;
  }

  if (role === RoleKind.Coach) {
    const coach = state.currentCoach();
    if (!coach) {
      router.navigate(['/login']);
      return false;
    }
    if (!coach.onboardingComplete) {
      state.setPendingCoach(coach.id);
      router.navigate(['/coach-onboarding']);
      return false;
    }
  }

  if (role === RoleKind.Parent && !state.currentParent()) {
    router.navigate(['/login']);
    return false;
  }

  if (role === RoleKind.Athlete && !state.currentAthlete()) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
